import React from 'react';
import { useMediaQuery } from 'react-responsive';

const MinSize = ({ children, breakpoint }) => {
  const smallScreen = useMediaQuery({
    query: `(min-width: ${breakpoint}px)`,
  });

  return smallScreen ? children : null;
};

export default MinSize;
